<template>
  <div class="main-content">
    <div class="card">
      <div class="card-body">
        <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" style="text-align: center"/>
        <template v-if="!loading && records.length">
          <table class="table mt-1 table-sm table-hover">
            <thead>
            <tr>
              <th></th>
              <th>Индекс</th>
              <th>Город</th>
              <th>Кол. Заявок</th>
              <th>На сумму</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(s,i) in records">
              <td>{{ i + 1 }}</td>
              <td>{{ s.index }}</td>
              <td>
                <template v-if="!regions[s.index] && s.index !== 'no_index'">
                  <button @click="getRegionName(s.index)" class="btn btn-xs btn-default">загрузить</button>
                </template>
                <template v-else>{{ regions[s.index] }}</template>
              </td>
              <td>{{ s.orders }}</td>
              <td>{{ s.totalSum }}</td>
            </tr>
            </tbody>
          </table>
        </template>
      </div>
    </div>
  </div>
</template>

<script>

import api from "@/api";

export default {
  data() {
    return {
      loading: false,
      records: [],
      regions: {},
    }
  },
  created() {
    this.getRecords();
  },
  methods: {
    async getRegionName(index) {
      this.regions[index] = 'загрузка...'
      this.regions = {...this.regions};
      const {data} = await api.index('orders/getAddressSuggest?q=' + encodeURIComponent(index + '00'));
      if (data.success) {
        this.regions[index] = data.suggestions[0]?.title;
      }
    },
    async getRecords() {
      this.loading = true;
      const {data} = await api.index('/statistics/postDirections')
      if (data.success) {
        this.records = _.orderBy(Object.values(data.records || {}), 'orders', 'desc');
      } else {
        toastr['warning'](data.message || 'Ошибка');
      }
      this.loading = false;
    }
  }
}

</script>
